"use client";

import React from "react";
import { ShieldCheck, Zap, Clock, Headphones } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function PartnerWithJadav() {
  const contactInfo = [{
    icon: <ShieldCheck className="size-7 text-[var(--color-accent)]" />,
    title: "معايير احترافية",
    desc: "نستخدم أحدث التقنيات والمبيدات الآمنة المعتمدة دولياً."
  }, {
    icon: <Clock className="size-7 text-[var(--color-accent)]" />,
    title: "خدمة 24/7",
    desc: "فريقنا متاح على مدار الساعة لتلبية احتياجاتكم الطارئة."
  }, {
    icon: <Headphones className="size-7 text-[var(--color-accent)]" />,
    title: "دعم فني مباشر",
    desc: "تواصل معنا عبر الهاتف أو البريد الإلكتروني في أي وقت."
  }];
  return <section data-section-id="223576" id="تواصل-معنا-الآن" className="bg-[var(--color-primary)] text-[var(--text-light)] py-24 lg:py-32 px-6 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-[80%] sm:w-[70%] lg:w-[600px] h-[600px] bg-[var(--color-accent)]/10 blur-[140px] rounded-full pointer-events-none -translate-y-1/2 translate-x-1/4" />
      <div className="absolute bottom-0 left-0 w-[80%] sm:w-[70%] lg:w-[600px] h-[500px] bg-[var(--color-accent)]/5 blur-[120px] rounded-full pointer-events-none translate-y-1/2 -translate-x-1/4" />
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-5 pointer-events-none" />
      
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-[1fr_1.3fr] gap-8 sm:gap-12 lg:gap-16 items-start relative z-10 p-6 sm:p-8 lg:p-10" dir="rtl">
        
        <div className="space-y-16 text-right lg:sticky lg:top-32">
          <div className="space-y-8">
            <div className="inline-flex items-center gap-3 px-5 py-2.5 rounded-full bg-[var(--text-light)]/5 border border-[var(--text-light)]/10 text-[var(--text-accent)] text-sm font-bold tracking-wide shadow-sm">
              <Zap className="size-5" />
              <span>استجابة سريعة خلال 30 دقيقة</span>
            </div>
            <h2 className="text-5xl md:text-6xl lg:text-7xl font-default font-bold tracking-tight leading-[1.15]">
              تواصل مع <br />
              <span className="text-[var(--text-accent)]">خبراء سرايا</span>
            </h2>
            <p className="text-xl text-[var(--color-muted-foreground)] leading-relaxed max-w-xl font-default">
              نحن هنا لخدمتكم في الرياض والمناطق المجاورة. فريقنا المتخصص جاهز لتقديم حلول مكافحة الحشرات والتعقيم بأعلى المعايير العالمية لضمان بيئة آمنة وصحية.
            </p>
          </div>

          <div className="grid gap-10">
            {contactInfo.map((item, i) => <div key={i} data-index={i} className="flex items-start gap-6 group">
                <div className="size-16 rounded-xl bg-[var(--color-secondary)]/50 flex items-center justify-center shrink-0 border border-[var(--text-light)]/10 group-hover:border-[var(--color-accent)]/40 group-hover:bg-[var(--color-secondary)] transition-all duration-300 shadow-md">
                  {item.icon}
                </div>
                <div className="space-y-2">
                  <h4 className="text-2xl font-default font-bold text-[var(--text-light)] group-hover:text-[var(--text-accent)] transition-colors">{item.title}</h4>
                  <p className="text-[var(--color-muted-foreground)] font-default leading-relaxed text-lg">{item.desc}</p>
                </div>
              </div>)}
          </div>
        </div>

        <div className="relative">
          <div className="absolute -inset-1 bg-gradient-to-tr from-[var(--color-accent)]/20 to-transparent blur-2xl rounded-xl pointer-events-none" />
          
          <Card className="border-[var(--text-light)]/10 shadow-2xl bg-[var(--color-secondary)]/60 backdrop-blur-2xl rounded-xl overflow-hidden relative border">
            <CardHeader className="pb-10 border-b border-[var(--text-light)]/5 text-right space-y-4 p-8 lg:p-10">
              <CardTitle className="text-4xl font-default font-bold text-[var(--text-light)]">طلب معاينة مجانية</CardTitle>
              <Link to="https://wa.me/966505276652" newTab className="text-3xl font-bold text-[var(--text-accent)] hover:opacity-80 transition-opacity block">
                0505276652
              </Link>
              <CardDescription className="text-xl font-default text-[var(--color-muted-foreground)]/80">
                املأ النموذج أدناه وسيقوم فريقنا الفني بالتواصل معك فوراً لترتيب موعد المعاينة.
              </CardDescription>
            </CardHeader>
            <CardContent className="p-8 lg:p-10">
              <div className="flex flex-col items-center justify-center py-12 text-center space-y-6">
                <p className="text-xl text-[var(--text-light)] font-default">
                  يمكنكم التواصل معنا مباشرة عبر الواتساب للحصول على استشارة فورية وحجز موعد المعاينة.
                </p>
                <Link to="https://wa.me/966505276652" newTab className="inline-flex items-center justify-center px-10 py-5 bg-[var(--color-accent)] text-[var(--color-primary)] font-bold text-xl rounded-full hover:scale-105 transition-transform shadow-lg shadow-[var(--color-accent)]/20">
                  تواصل عبر الواتساب الآن
                </Link>
              </div>
            </CardContent>
          </Card>
        </div>

      </div>
    </section>;
}